import Vue from 'vue';

Vue.component('bookmark-article-vue', {
  data() {
    return {
      isArticleSaved: false
    };
  },
  methods: {
    toggleSaved() {
      this.isArticleSaved = !this.isArticleSaved;
    }
  }
});
